module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "c11"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }), _vm._v("Ring in the Holidays")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "dropcaps"
  }, [_vm._v("B")]), _vm._v("eing the very model of a modern mature woman, Janne Grim decided she would propose to her boyfriend as opposed to the traditional vice-versa. The young Norwegian woman invited her boyfriend Svein Froeytland to a Christmas party and hid the wedding ring in his porridge. She watched impatiently as he wolfed down the porridge but when he didn’t mention the ring she took that as a “no.” After swallowing her pride, Janne told Svein about the proposed proposal, and he told her he must have swallowed the ring. He accepted her proposal and, borrowing a ring from one of the guests, made the engagement official. Svein said, “Now that I am twenty-four karats heavier, I will have to wait for nature to take its course. Then the ring will take its course, and everything will work out in the end.”"), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/Greg_9780740792069_epub_L04_r1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "textbox"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/Greg_9780740792069_epub_L05_r1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_vm._v("CHICK ACCUSES SOME OF HER"), _c('br'), _vm._v("MALE COLLEAGUES OF SEXISM")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/Greg_9780740792069_epub_L06_r1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Article concerning allegations of sexism"), _c('br'), _vm._v("from then-councilwoman, now Los Angeles City Controller Laura Chick."), _c('br'), _vm._v("— "), _c('em', [_vm._v("The Los Angeles Times,")]), _vm._v(" June 23, 1998")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b5065c1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780740792069_epub_c11_r1.vue
// module id = 105
// module chunks = 0